/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
    'use strict';

    /**
     * Вид для групп форм самовывоза
     */
    app.JointPurchaseDeliveryPickupGroupFormsView = app.JointPurchaseDeliveryGroupFormsView.extend({
        el: '#delivery_pickup_info_block',

        listSelector: '.js-delivery-pickups-group-forms-list',

        events: {
            'click .js-add-delivery-pickup-city': 'addDeliveryGroupCity',
            'input .input_price.input_styled': 'deleteNonNumericValue'
        },

        jpSettlementIds: [],

        /**
         * Рендерит новую группу самовывоза
         *
         * @param settlement
         * @param districts
         * @param models
         */
        renderNewDeliveryGroupForm: function (settlement, districts, models) {
            var jpDeliveryPickupsCollection = new app.Collection(models);
            jpDeliveryPickupsCollection.url = app.entryScriptName + '/api/v3/jp-delivery-pickup';
            var newDeliveryPickupsGroupFormsView = new app.JointPurchaseDeliveryPickupFormsView({
                parentView: this,
                model: jpDeliveryPickupsCollection,
                districts: districts,
                settlement: settlement
            });
            this.$(this.listSelector).append(newDeliveryPickupsGroupFormsView.$el);
            this.childViews.formViews.push(newDeliveryPickupsGroupFormsView);
            if (settlement) {
                this.jpSettlementIds.push(settlement.id || settlement.settlement_id);
            }
        },

        deleteNonNumericValue: function (e) {
          var $target = $(e.target),
            newValue = $target.val();
          //убираем не цифры
          newValue = newValue.replace(/[^0-9-]/g, '');
          //убираем нули в начале
          newValue = newValue.replace(/\b0+/g, '');
          $target.val(newValue);
        }
    });
})();

}.call(window));